/* ═══════ Paintly cart drawer engine — ported from Paintly-CartDrawer-v16-Final proto ═══════
   State computed from #pkCartData (re-rendered by Liquid on every cart update).
   Re-initializes via MutationObserver whenever Shrine re-renders the drawer. */
(function () {
  'use strict';
  var GIFT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="9" width="18" height="4" rx="1"/><path d="M5 13v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6M12 9v12M12 9c-2 0-4.5-.8-4.5-3A2 2 0 0 1 10 4c2 0 2 3 2 5zm0 0c2 0 4.5-.8 4.5-3A2 2 0 0 0 14 4c-2 0-2 3-2 5z"/></svg>';
  var CAL = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="5" width="18" height="16" rx="2"/><path d="M8 3v4M16 3v4M3 11h18"/></svg>';
  /* recipient rows are rendered as chips instead, so they come out of the raw property list */
  var GIFT_PROPS = ['recipient email', 'recipient name', 'send on', 'message'];
  var PK_MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  function giftDate(v) {
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(v || ''));
    if (!m) return '';
    var mi = parseInt(m[2], 10) - 1;
    if (mi < 0 || mi > 11) return '';
    return parseInt(m[3], 10) + ' ' + PK_MON[mi] + ' ' + m[1];
  }
  var CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 7L9 18l-5-5"/></svg>';
  var PALETTE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3C7 3 3 7 3 12s4 9 9 9c1.3 0 2.2-.9 2.2-2.1 0-.6-.2-1-.6-1.4-.4-.4-.6-.9-.6-1.4a2 2 0 0 1 2-2H17a5 5 0 0 0 5-5c0-3.7-4.5-6.1-10-6.1z"/><circle cx="7.6" cy="10.6" r="1.15" fill="currentColor" stroke="none"/><circle cx="11.3" cy="7.2" r="1.15" fill="currentColor" stroke="none"/><circle cx="15.9" cy="8.4" r="1.15" fill="currentColor" stroke="none"/></svg>';
  var GEM = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M7 4h10l4 5-9 11L3 9z"/><path d="M3 9h18M12 20L8.5 9M12 20l3.5-11"/></svg>';
  var PEARL = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><circle cx="7.6" cy="9.4" r="3.9"/><circle cx="16.4" cy="9.4" r="3.9"/><circle cx="12" cy="16.6" r="3.9"/></svg>';
  var FXC = ['#C5FF89', '#A6E85F', '#CEA3D9', '#9A6BB0', '#DDD0E6', '#3B303E'];

  var CUR = { iso: 'USD', sym: '$' }; /* updated from the cart blob each render */
  function money(cents) {
    return CUR.sym + (cents / 100).toFixed(2);
  }
  function codeFromData(d) {
    /* the cart itself is the source of truth: any discount application of type
       'discount_code' on the cart or its lines means a code is on.
       Returns the whole application ({t,n,vt,v}) so the caller can tell a percentage
       code from a fixed-amount one — the code's own characters say nothing. */
    var found = null;
    function take(a) { if (a && a.t === 'discount_code' && !found) found = a; }
    (d.cart_apps || []).forEach(take);
    (d.items || []).forEach(function (x) { (x.apps || []).forEach(take); });
    return found;
  }
  function refreshDrawer() {
    return fetch('/?sections=cart-drawer').then(function (r) { return r.json(); }).then(function (j) {
      var html = j['cart-drawer']; if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('#CartDrawer');
      var cur = document.getElementById('CartDrawer');
      if (fresh && cur) cur.innerHTML = fresh.innerHTML;
      var freshCd = doc.querySelector('cart-drawer');
      var curCd = document.querySelector('cart-drawer');
      if (freshCd && curCd) curCd.classList.toggle('is-empty', freshCd.classList.contains('is-empty'));
      setTimeout(render, 60);
    }).catch(function () { setTimeout(render, 60); });
  }
  function readData() {
    var el = document.getElementById('pkCartData');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function computeState(d) {
    /* IMPORTANT: discounts apply IN the cart on this store, so d.total is already the real
       amount payable and d.total_discount already carries the saving. The two kinds land in
       different places though: the B2G1 automatic deal is a LINE-level allocation, a whole-order
       code is a CART-level one. "original" below is the pre-discount goods total and must be
       correct for both; all display math starts from it. */
    var units = [];
    d.items.forEach(function (x, li) {
      /* gift cards are outside the Buy-2-Get-1 discount scope in Shopify — they must
         not count as "kits" toward the every-3rd-kit meter or the free-unit estimate */
      if (x.gift) return;
      for (var k = 0; k < x.qty; k++) units.push({ li: li, p: x.price });
    });
    var n = units.length;
    /* Pre-discount goods total. d.goods is summed in Liquid from item.original_line_price,
       so it is right for BOTH kinds of discount. Do NOT go back to subtotal+total_discount:
       cart.items_subtotal_price is net of LINE-level discounts only, so a whole-order code
       (which Shopify applies at cart level) is still inside it and adding the discount back
       double-counts it — that was the phantom "was" figure the drawer used to show.
       The item sum is a fallback for the first render after a JS-before-Liquid deploy. */
    var original = d.goods;
    if (typeof original !== 'number' || original <= 0) {
      original = 0;
      d.items.forEach(function (x) { original += x.price * x.qty; });
    }
    var codeApp = codeFromData(d);
    var code = codeApp ? { label: String(codeApp.n).toUpperCase(), vt: codeApp.vt || '', pct: 0, txt: '' } : null;
    var freeCount = 0, save = 0, codeOff = 0, freeBy = {}, realDeal = false, paid;
    if (code) {
      /* code is ON the cart: every number is Shopify's real math */
      codeOff = d.total_discount;
      paid = d.total;
      /* the percentage is derived from the money, never scraped out of the code's characters */
      code.pct = original > 0 ? Math.round(codeOff / original * 100) : 0;
      if (codeOff <= 0) code.txt = '';                                   /* shipping-only, or nothing to discount */
      else if (code.vt === 'fixed_amount') code.txt = money(codeOff) + ' off';
      else code.txt = code.pct + '% off';
    } else if (d.total_discount > 0) {
      /* trust Shopify's real automatic discount */
      realDeal = true;
      save = d.total_discount;
      freeCount = Math.floor(n / 3);
      paid = d.total;
      d.items.forEach(function (x, li) {
        if (x.line_discount > 0 && x.price > 0) freeBy[li] = Math.min(x.qty, Math.round(x.line_discount / x.price));
      });
    } else {
      /* estimate (under 3 kits, or discount not yet reported) */
      freeCount = Math.floor(n / 3);
      units.sort(function (a, b) { return a.p - b.p; });
      units.slice(0, freeCount).forEach(function (u) {
        save += u.p;
        freeBy[u.li] = (freeBy[u.li] || 0) + 1;
      });
      paid = original - save;
    }
    var fill = n === 0 ? 0 : (n % 3 === 0 ? 3 : n % 3);
    var left = n === 0 ? 3 : (n % 3 === 0 ? 3 : 3 - (n % 3));
    return {
      n: n, sub: original, freeCount: freeCount, save: save, codeOff: codeOff, freeBy: freeBy,
      code: code, realDeal: realDeal, tot: paid, fill: fill, left: left, lap: n > 0 && n % 3 === 0,
      shipPct: Math.min(100, paid / d.ship_free * 100),
      shipLeft: Math.max(0, d.ship_free - paid),
      shipDone: paid >= d.ship_free && n > 0
    };
  }

  /* ── fx ── */
  var parts = [], fxRun = false;
  function fxCanvas() {
    var inner = document.querySelector('.cart-drawer .drawer__inner');
    if (!inner) return null;
    var cv = inner.querySelector('#pkFx');
    if (!cv) {
      cv = document.createElement('canvas'); cv.id = 'pkFx';
      inner.appendChild(cv);
      var fo = document.createElement('div'); fo.className = 'pk-flashov'; inner.appendChild(fo);
      var bb = document.createElement('div'); bb.className = 'pk-bigban'; inner.appendChild(bb);
      if (getComputedStyle(inner).position === 'static') inner.style.position = 'relative';
    }
    cv.width = inner.clientWidth; cv.height = inner.clientHeight;
    return cv;
  }
  function blast(x, y, nn) {
    var cv = fxCanvas(); if (!cv) return;
    var n = nn || 110;
    for (var i = 0; i < n; i++) {
      var a = Math.random() * Math.PI * 2, sp = 2 + Math.random() * 8;
      parts.push({ x: x, y: y, vx: Math.cos(a) * sp, vy: Math.sin(a) * sp - 4 - Math.random() * 3,
        g: .16 + Math.random() * .09, w: 4 + Math.random() * 7, h: 3 + Math.random() * 5,
        rot: Math.random() * 6.28, vr: (Math.random() - .5) * .4, c: FXC[i % FXC.length],
        shape: i % 4, life: 90 + Math.random() * 50, drag: .985 });
    }
    if (!fxRun) fxLoop(cv);
  }
  function fxLoop(cv) {
    fxRun = true;
    var cx = cv.getContext('2d');
    cx.clearRect(0, 0, cv.width, cv.height);
    parts.forEach(function (p) {
      p.vx *= p.drag; p.vy = p.vy * p.drag + p.g; p.x += p.vx; p.y += p.vy; p.rot += p.vr; p.life--;
      cx.save(); cx.translate(p.x, p.y); cx.rotate(p.rot);
      cx.globalAlpha = Math.max(0, Math.min(1, p.life / 40)); cx.fillStyle = p.c;
      if (p.shape === 0) cx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
      else if (p.shape === 1) { cx.beginPath(); cx.arc(0, 0, p.w / 2, 0, 6.29); cx.fill(); }
      else if (p.shape === 2) { cx.beginPath(); cx.moveTo(0, -p.w / 2); cx.lineTo(p.w / 2, 0); cx.lineTo(0, p.w / 2); cx.lineTo(-p.w / 2, 0); cx.closePath(); cx.fill(); }
      else cx.fillRect(-p.w / 2, -1.2, p.w, 2.4);
      cx.restore();
    });
    parts = parts.filter(function (p) { return p.life > 0 && p.y < cv.height + 30; });
    if (parts.length) requestAnimationFrame(function () { fxLoop(cv); });
    else { fxRun = false; cx.clearRect(0, 0, cv.width, cv.height); }
  }
  function elCenter(el) {
    var inner = document.querySelector('.cart-drawer .drawer__inner');
    if (!inner || !el) return [200, 140];
    var d = inner.getBoundingClientRect(), r = el.getBoundingClientRect();
    return [r.left - d.left + r.width / 2, r.top - d.top + r.height / 2];
  }
  function megaMoment(anchor, text) {
    var c = elCenter(anchor);
    blast(c[0], c[1], 130);
    var inner = document.querySelector('.cart-drawer .drawer__inner');
    if (!inner) return;
    var fo = inner.querySelector('.pk-flashov');
    if (fo && fo.animate) fo.animate([{ opacity: .28 }, { opacity: 0 }], { duration: 520, easing: 'ease-out' });
    var rp = document.createElement('span'); rp.className = 'pk-ripple';
    rp.style.cssText = 'left:' + c[0] + 'px;top:' + c[1] + 'px;width:340px;height:340px';
    inner.appendChild(rp); setTimeout(function () { rp.remove(); }, 950);
    if (inner.animate) inner.animate([{ transform: 'translate(0,0)' }, { transform: 'translate(-3px,2px)' }, { transform: 'translate(3px,-2px)' }, { transform: 'translate(0,0)' }], { duration: 340 });
    var bb = inner.querySelector('.pk-bigban');
    if (bb) { bb.textContent = text; bb.classList.remove('go'); void bb.offsetWidth; bb.classList.add('go'); }
  }

  /* ── meter ── */
  function renderTrack(s) {
    var t = document.getElementById('pkTrkl'); if (!t) return;
    /* at an exact lap, back up one round (full tube + glowing won gift) until the slide runs */
    var slid = false;
    try {
      var sv = parseInt(sessionStorage.getItem('pk_slid') || '0', 10) || 0;
      if (sv > s.freeCount) { sessionStorage.removeItem('pk_slid'); sv = 0; } /* stale from an earlier, higher round */
      slid = s.freeCount > 0 && sv === s.freeCount;
    } catch (e) {}
    var R = (s.lap && s.freeCount > 0 && !slid) ? s.freeCount - 1 : s.freeCount, h = '';
    for (var j = 0; j < 12; j++) {
      var kitNo = 3 * R + j + 1, x = ((j + 0.5) / 9 * 94).toFixed(3) + '%';
      if ((j + 1) % 3 === 0) {
        var gn = R + (j + 1) / 3;
        h += '<span class="pk-gf" data-kit="' + kitNo + '" style="left:' + x + '">' + GIFT + '<span class="pk-gl2">Free kit ' + gn + '</span></span>';
      } else {
        h += '<span class="pk-mk" data-kit="' + kitNo + '" style="left:' + x + '"><i>' + kitNo + '</i></span>';
      }
    }
    t.innerHTML = h;
    t.querySelectorAll('.pk-mk').forEach(function (mk) {
      if (s.n >= +mk.dataset.kit) { mk.classList.add('on'); mk.innerHTML = CHECK; }
    });
    var nextFound = false;
    t.querySelectorAll('.pk-gf').forEach(function (g) {
      var won = s.n >= +g.dataset.kit;
      g.classList.toggle('won', won);
      if (!won && !nextFound) {
        nextFound = true; g.classList.add('nxt');
        if (s.left === 1 && !s.lap) g.classList.add('near');
      }
    });
    var lf = document.getElementById('pkLfill');
    var prog = Math.max(0, Math.min(3, s.n - 3 * R));
    if (lf) lf.style.width = (prog / 9 * 94) + '%';
  }

  function dealMsg(s) {
    if (s.n === 0) return 'Every 3rd kit is <span class="hl">FREE</span>. Add any 3 kits — the cheapest one costs ' + CUR.sym + '0.';
    if (s.lap) return '<b>You just got free kit ' + s.freeCount + '!</b> Add 3 more kits and free kit ' + (s.freeCount + 1) + ' is yours too — <span class="hl">it never stops</span>.';
    var another = s.freeCount > 0 ? 'another kit is' : 'your 3rd kit is';
    return '<b>' + s.n + ' ' + (s.n === 1 ? 'kit' : 'kits') + ' in your cart</b> — just ' + s.left + ' more and ' + another + ' <span class="hl">FREE</span>.';
  }

  function decorateItems(d, s) {
    d.items.forEach(function (x, li) {
      var row = document.getElementById('CartDrawer-Item-' + x.index);
      if (!row) return;
      row.querySelectorAll('.pk-rowmeta,.pk-lineprice,.pk-giftmsg').forEach(function (n) { n.remove(); });
      /* the craft pill announces PBN/DP — drop the redundant title suffix like
         "(80 Color Paint by Numbers)" / "(150 Color Diamond Painting)" (idempotent) */
      var dl = row.querySelector('.cart-item__details dl');
      if (dl) {
        if (x.gift) {
          /* Drop the raw "Recipient name: … Send on: 2026-08-15 Message: …" dump.
             Remove the property rows themselves before the list is flattened — the
             chips below say the same thing in a way the customer can actually read. */
          var opts = dl.querySelectorAll('.product-option');
          for (var pi = 0; pi < opts.length; pi++) {
            var dt = opts[pi].querySelector('dt');
            var pn = dt ? dt.textContent.replace(/:\s*$/, '').trim().toLowerCase() : '';
            if (pn && GIFT_PROPS.indexOf(pn) > -1 && opts[pi].parentNode) opts[pi].parentNode.removeChild(opts[pi]);
          }
        }
        var vt = dl.textContent.replace(/\s+/g, ' ').trim();
        if (dl.textContent !== vt) dl.textContent = vt;
      }
      var nameEl = row.querySelector('.cart-item__name');
      if (nameEl) {
        var stripped = nameEl.textContent.trim().replace(/\s*\(([^)]*(paint\s*by\s*numbers|diamond\s*painting|board\s*canvas|pearl\s*painting)[^)]*)\)\s*$/i, '');
        if (stripped && stripped !== nameEl.textContent.trim()) nameEl.textContent = stripped;
      }
      var meta = document.createElement('div');
      meta.className = 'pk-rowmeta';
      var pill;
      if (x.gift) {
        /* a gift card is neither craft — label it as itself, not "Paint by Numbers" */
        pill = '<span class="pk-craft gift">' + GIFT + 'Gift card</span>';
      } else if (/pearl[\s-]*painting/i.test(x.title + ' ' + x.handle)) {
        /* a pearl painting is its own craft (26 Oct 2026) */
        pill = '<span class="pk-craft pearl">' + PEARL + 'Pearl Painting</span>';
      } else {
        var isDP = /diamond/i.test(x.title + ' ' + x.handle);
        /* carry the color count into the pill (the title suffix it came from is stripped) */
        var cm = String(x.title).match(/(\d+)\s*colors?\b/i);
        var craftLabel = (cm ? cm[1] + ' Color ' : '') + (isDP ? 'Diamond Painting' : 'Paint by Numbers');
        pill = '<span class="pk-craft ' + (isDP ? 'dp' : 'pbn') + '">' + (isDP ? GEM : PALETTE) + craftLabel + '</span>';
      }
      var photo = '';   /* 8 Oct 2026: no photo chip; the kit's own picture shows instead */
      if (x.gift) {
        photo = '';
        if (x.gift_to) photo += '<span class="pk-photochip pk-giftto">' + CHECK + 'To ' + String(x.gift_to).replace(/[<>&"]/g, '') + '</span>';
        var gd = giftDate(x.gift_date);
        if (gd) photo += '<span class="pk-photochip pk-giftdate">' + CAL + 'Sends ' + gd + '</span>';
      }
      var chip = '';
      var orig = x.price * x.qty, priceHtml = money(orig);
      if (s.code) {
        if (x.line_discount > 0) {
          /* this line's own saving, not the order-wide figure — a code can apply to some lines only */
          var lpct = orig > 0 ? Math.round(x.line_discount / orig * 100) : 0;
          var lbl = (s.code.vt === 'fixed_amount' || lpct <= 0) ? money(x.line_discount) : lpct + '%';
          chip = '<span class="pk-freechip">-' + lbl + '</span>';
          priceHtml = '<s>' + money(orig) + '</s>' + money(orig - x.line_discount);
        }
      } else if (s.realDeal) {
        if (x.line_discount > 0) {
          var fuR = Math.min(x.qty, Math.round(x.line_discount / x.price));
          chip = '<span class="pk-freechip">' + (fuR === x.qty ? 'FREE' : fuR + ' FREE') + '</span>';
          priceHtml = '<s>' + money(orig) + '</s>' + money(orig - x.line_discount);
        }
      } else {
        var fu = s.freeBy[li] || 0;
        if (fu > 0) {
          chip = '<span class="pk-freechip">' + (fu === x.qty ? 'FREE' : fu + ' FREE') + '</span>';
          priceHtml = '<s>' + money(orig) + '</s>' + money(x.price * (x.qty - fu));
        }
      }
      meta.innerHTML = pill + photo + chip;
      var host = row.querySelector('.cart-item__details') || row.querySelector('[class*="details"]') || row;
      host.appendChild(meta);
      if (x.gift && String(x.gift_msg || '').trim()) {
        var gm = document.createElement('div');
        gm.className = 'pk-giftmsg';
        gm.textContent = '\u201C' + String(x.gift_msg).trim() + '\u201D';
        host.appendChild(gm);
      }
      var pr = document.createElement('div');
      pr.className = 'pk-lineprice';
      pr.innerHTML = priceHtml;
      host.appendChild(pr);
    });
  }

  function pkSlide(fc) {
    var t = document.getElementById('pkTrkl'); if (!t) return;
    var d2 = readData(); if (!d2) return;
    var s2 = computeState(d2);
    if (!s2.lap || s2.freeCount !== fc || s2.code) return;   /* cart changed meanwhile */
    try { if (sessionStorage.getItem('pk_slid') === String(fc)) return; } catch (e) {} /* already slid this round */
    /* panel collapsed on mobile → no visual stage; just commit the state */
    if (document.documentElement.classList.contains('pk-folded') && window.matchMedia('(max-width: 480px)').matches) {
      try { sessionStorage.setItem('pk_slid', String(fc)); } catch (e) {}
      render();
      return;
    }
    if (pkMo) pkMo.disconnect();
    var lw = document.getElementById('pkLanewrap');
    if (lw) lw.classList.add('sliding'); /* clip hard at the lane's left edge while markers travel */
    t.style.transition = 'transform .65s cubic-bezier(.35,.8,.3,1)';
    t.style.transform = 'translateX(-31.333%)';
    var lf = document.getElementById('pkLfill'); if (lf) lf.style.width = '0%';
    var doneRan = false;
    var done = function () {
      if (doneRan) return; doneRan = true;
      t.removeEventListener('transitionend', done);
      try { sessionStorage.setItem('pk_slid', String(fc)); } catch (e) {}
      t.style.transition = 'none';
      t.style.transform = '';
      render();
      if (lw) lw.classList.remove('sliding');
      setTimeout(function () { t.style.transition = ''; }, 60);
    };
    t.addEventListener('transitionend', done);
    setTimeout(done, 1100); /* fallback if transitionend never fires (tab hidden, element replaced) */
    setTimeout(function () { pkObserve(); }, 800);
  }
  function pkCloseIcon() {
    var xb = document.querySelector('.cart-drawer .drawer__header .drawer__close');
    if (xb && !xb.dataset.pk) {
      xb.dataset.pk = '1';
      xb.innerHTML = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M5 5l14 14M19 5L5 19"/></svg>';
    }
  }
  var pkMo = null;
  function pkObserve() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && pkMo) pkMo.observe(drawer, { childList: true, subtree: true });
  }
  /* Roadmap 7a. Keep the minus glyph honest: at quantity 1 the button removes the
     line rather than decreasing it, so it shows a bin. The server renders the first
     state; this keeps it right afterwards. Called from renderInner, which the drawer's
     MutationObserver already runs on every re-render, and again straight after a tap so
     the glyph flips immediately rather than waiting for the cart round trip. */
  function syncMinus() {
    var rows = document.querySelectorAll('.cart-drawer-item');
    for (var i = 0; i < rows.length; i++) {
      var inp = rows[i].querySelector('.quantity__input');
      var btn = rows[i].querySelector('.quantity__button--minus');
      if (!inp || !btn) continue;
      var one = (parseInt(inp.value, 10) || 1) <= 1;
      btn.classList.toggle('pk-willremove', one);
    }
  }

  function render() {
    if (document.documentElement.hasAttribute('data-pk-kit-updating') || document.documentElement.hasAttribute('data-pk-kit-stale')) return;
    if (pkMo) pkMo.disconnect();
    try { renderInner(); } finally { pkObserve(); }
  }
  function renderInner() {
    pkCloseIcon();
    syncMinus();
    var eb = document.querySelector('.cart-drawer__empty-content .button');
    if (eb && !eb.dataset.pk) {
      eb.dataset.pk = '1';
      eb.insertAdjacentHTML('beforeend', '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M4 12h15M13 6l6 6-6 6"/></svg>');
    }
    var d = readData(); if (!d) return;
    if (d.cur && d.cur.iso) CUR = d.cur;
    var s = computeState(d);
    var panel = document.getElementById('pkPanel'); if (!panel) return;
    panel.classList.toggle('codeon', !!s.code);
    /* collapsed state lives on <html>; default = collapsed on mobile when the cart has items
       (empty drawer keeps the panel open — it's the hook there). Manual choice wins for the session. */
    var pkStored = null; try { pkStored = sessionStorage.getItem('pk_fold'); } catch (eF) {}
    var pkFolded = pkStored === null
      ? (window.matchMedia('(max-width: 480px)').matches && s.n > 0)
      : pkStored === '1';
    document.documentElement.classList.toggle('pk-folded', pkFolded);
    /* header count */
    var hc = document.getElementById('pkCount') || null;
    /* pill */
    var pill = document.getElementById('pkPill');
    if (pill) {
      if (s.freeCount > 0) { pill.className = 'pk-pill'; pill.textContent = s.freeCount + ' FREE · -' + money(s.save); }
      else if (pkFolded) { pill.className = 'pk-pill'; pill.textContent = 'VIEW OFFERS'; }
      else { pill.className = 'pk-pill zero'; pill.textContent = 'NO LIMIT'; }
    }
    var msg = document.getElementById('pkMsg');
    if (msg) {
      msg.innerHTML = dealMsg(s);
      /* on mobile only actionable moments keep the message line (CSS hides the rest):
         empty-cart teaser, 1 kit away, or a just-completed round */
      msg.classList.toggle('key', s.n === 0 || s.n % 3 === 2 || (s.lap && s.freeCount > 0));
    }
    /* panel internals stay hidden (CSS :not(.pk-ready)) until this render pass fills them */
    panel.classList.add('pk-ready');
    /* short placeholder on narrow screens so it never clips behind Apply */
    var ci = document.getElementById('pkCcIn');
    if (ci && ci.placeholder.indexOf('already used') === -1) ci.placeholder = window.matchMedia('(max-width: 480px)').matches ? 'Discount code' : 'Have a discount code? Enter it here';
    renderTrack(s);
    /* code ticket */
    var cc = document.getElementById('pkCodecard');
    if (cc) {
      cc.classList.toggle('on', !!s.code);
      if (s.code) {
        var cn = document.getElementById('pkCcName');
        cn.textContent = s.code.label;
        var L = s.code.label.length;
        cn.style.fontSize = L > 12 ? '13px' : (L > 9 ? '15px' : '19px');
        /* whole sub-line is rewritten: a shipping-only or zero-value code must not
           read "0% off your whole order" */
        var cs = document.getElementById('pkCcSub');
        if (cs) {
          cs.innerHTML = s.code.txt
            ? '<b id="pkCcPct">' + s.code.txt + '</b> your whole order &middot; code applied'
            : '<b id="pkCcPct">Code applied</b>';
        }
        document.getElementById('pkCnote').innerHTML = s.codeOff > 0
          ? "You're saving <b>" + money(s.codeOff) + '</b> on this order' + (s.shipDone ? ', and shipping is free' : '') + '.'
          : 'Your code is on this order' + (s.shipDone ? ', and shipping is free' : '') + '.';
      }
    }
    /* shipping lane */
    var ship = document.getElementById('pkShip');
    if (ship) {
      /* A gift card is delivered by email, so a gift-card-only cart ships nothing.
         "$10 to free shipping" would be a promise about a parcel that never exists. */
      var noShip = d.requires_shipping === false && d.items && d.items.length > 0;
      ship.style.display = noShip ? 'none' : '';
      if (!noShip) {
        ship.classList.toggle('done', s.shipDone);
        document.getElementById('pkRoadfill').style.width = s.shipPct + '%';
        /* park the truck just short of the finish flag (flag owns the last ~28px) */
        document.getElementById('pkTrk').style.left = 'min(' + Math.min(s.shipPct, 97) + '%, 100% - 28px)';
        document.getElementById('pkHlb').innerHTML = s.shipDone ? 'Free shipping<b>UNLOCKED</b>' : 'to free shipping<b>' + money(s.shipLeft) + '</b>';
      }
    }
    /* footer */
    var cf = document.getElementById('pkCodefield');
    if (cf) cf.classList.toggle('codeon', !!s.code);
    var sub = document.getElementById('pkSub'); if (sub) sub.textContent = money(s.sub);
    var sr = document.getElementById('pkSaveRow');
    if (sr) {
      sr.style.display = s.save > 0 ? 'flex' : 'none';
      if (s.save > 0) {
        document.getElementById('pkSaveLbl').textContent = 'Every 3rd kit free (' + s.freeCount + ' free ' + (s.freeCount === 1 ? 'kit' : 'kits') + ')';
        document.getElementById('pkSaveAmt').textContent = '-' + money(s.save);
      }
    }
    var cr = document.getElementById('pkCodeRow');
    if (cr) {
      cr.style.display = s.codeOff > 0 ? 'flex' : 'none';
      if (s.codeOff > 0) {
        document.getElementById('pkCodeLbl').textContent = 'Code ' + s.code.label;
        document.getElementById('pkCodeAmt').textContent = '-' + money(s.codeOff);
      }
    }
    var sc = document.getElementById('pkSavecard');
    if (sc) {
      var totSave = s.save + s.codeOff;
      sc.classList.toggle('on', totSave > 0);
      if (totSave > 0) {
        var partsTxt = [];
        if (s.freeCount > 0) partsTxt.push(s.freeCount + ' free ' + (s.freeCount === 1 ? 'kit' : 'kits'));
        if (s.code) partsTxt.push('code ' + s.code.label + (s.code.txt ? ' (' + s.code.txt + ')' : ''));
        if (s.shipDone) partsTxt.push('free shipping');
        document.getElementById('pkScSub').textContent = partsTxt.join(' · ');
        document.getElementById('pkScWas').textContent = 'was ' + money(s.sub);
        document.getElementById('pkScAmt').textContent = '-' + money(totSave);
      }
    }
    var tot = document.getElementById('pkTot'); if (tot) tot.textContent = money(s.tot) + ' ' + CUR.iso;
    decorateItems(d, s);
    /* unlock spectacle: compare stored freeCount */
    try {
      var prev = +(sessionStorage.getItem('pk_prev_free') || 0);
      if (s.freeCount > prev && !s.code) {
        var g = document.querySelector('#pkTrkl .pk-gf.won') || document.querySelector('#pkTrkl .pk-gf') || panel;
        /* collapsed on mobile → the gift markers are display:none; anchor the celebration to the panel */
        if (document.documentElement.classList.contains('pk-folded') && window.matchMedia('(max-width: 480px)').matches) g = panel;
        setTimeout(function () { megaMoment(g, 'FREE KIT ' + s.freeCount + ' UNLOCKED'); }, 250);
        setTimeout(function () { pkSlide(s.freeCount); }, 1500);
      }
      sessionStorage.setItem('pk_prev_free', String(s.freeCount));
    } catch (e) {}
  }

  function wire() {
    document.addEventListener('paintly:kit-cart-settled', render);
    /* ?pkdebug=1 → tiny on-screen diagnostics badge (scale, widths, input font, media flags) */
    if (/pkdebug/.test(location.search)) {
      var dbg = document.createElement('div');
      dbg.style.cssText = 'position:fixed;left:8px;bottom:8px;z-index:2147483647;background:#000;color:#7CFC00;font:11px/1.5 monospace;padding:6px 9px;border-radius:8px;opacity:.92;pointer-events:none;max-width:90vw';
      document.body.appendChild(dbg);
      var upd = function () {
        var inp = document.getElementById('pkCcIn');
        var vv = window.visualViewport;
        dbg.textContent = 'scale:' + (vv ? vv.scale.toFixed(2) : '?')
          + ' iw:' + window.innerWidth + ' sw:' + document.documentElement.scrollWidth
          + ' fs:' + (inp ? getComputedStyle(inp).fontSize : '-')
          + ' coarse:' + (matchMedia('(pointer: coarse)').matches ? 1 : 0)
          + ' hovNone:' + (matchMedia('(hover: none)').matches ? 1 : 0)
          + ' foc:' + (document.activeElement && document.activeElement.id === 'pkCcIn' ? 1 : 0);
      };
      setInterval(upd, 400); upd();
    }
    /* iOS focus-zoom killer: Safari only auto-zooms on NATIVE tap-focus. Intercept the
       tap on the code field and focus it programmatically — keyboard still opens
       (same user gesture), zoom never fires. */
    document.addEventListener('touchend', function (e) {
      var inp = e.target.closest && e.target.closest('#pkCcIn');
      if (!inp || document.activeElement === inp) return;
      e.preventDefault();
      inp.focus();
    }, { passive: false });
    /* mobile chevron: collapse/expand the offer panel, remembered for the session.
       When folded, the whole title row is a tap target. */
    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      var f = e.target.closest('#pkFold');
      var row = !f && document.documentElement.classList.contains('pk-folded') && e.target.closest('#pkPanel .pk-a1');
      if (!f && !row) return;
      var now = !document.documentElement.classList.contains('pk-folded');
      document.documentElement.classList.toggle('pk-folded', now);
      try { sessionStorage.setItem('pk_fold', now ? '1' : '0'); } catch (err) {}
      var fb = document.getElementById('pkFold'); if (fb) fb.setAttribute('aria-expanded', now ? 'false' : 'true');
      render(); /* pill copy depends on fold state (VIEW OFFERS ↔ NO LIMIT) */
    });
    /* proto behavior: the minus button at qty 1 removes the line (trash is hidden) */
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.cart-drawer-item .quantity__button[name="plus"]')) setTimeout(syncMinus, 0);
      var minus = e.target.closest && e.target.closest('.cart-drawer-item .quantity__button[name="minus"]');
      if (!minus) return;
      var row = minus.closest('.cart-drawer-item');
      var inp = row && row.querySelector('.quantity__input');
      if (inp && parseInt(inp.value, 10) <= 1) {
        e.preventDefault(); e.stopPropagation();
        var rm = row.querySelector('.cart-drawer-item__cart-remove-button button, .cart-drawer-item__cart-remove-button a');
        if (rm) rm.click();
      } else {
        /* dropping to 1 turns this same button into the delete control, so say so
           now instead of after the cart responds */
        setTimeout(syncMinus, 0);
      }
    }, true);
    document.addEventListener('input', function (e) {
      if (e.target && e.target.id === 'pkCcIn') {
        var cf = document.getElementById('pkCodefield');
        if (cf) cf.classList.toggle('hasval', !!e.target.value.trim());
      }
    });
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest && t.closest('#pkCcApply')) {
        var inp = document.getElementById('pkCcIn');
        /* strip ALL whitespace — mobile autocorrect loves inserting spaces mid-code */
        var v = (inp && inp.value || '').replace(/\s+/g, '');
        if (!v) return;
        fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ discount: v.toUpperCase() }) })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var ok = (cart.discount_codes || []).some(function (c) { return c.code && c.code.toUpperCase() === v.toUpperCase() && c.applicable; });
            return refreshDrawer().then(function () {
              if (ok) {
                var cc = document.getElementById('pkCodecard');
                setTimeout(function () { megaMoment(cc, 'CODE ' + v.toUpperCase() + ' APPLIED'); }, 200);
              } else {
                /* detach the refused code so it doesn't linger on the cart */
                fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ discount: '' }) }).catch(function () {});
                var showErr = function () {
                  var f = document.getElementById('pkCodefield');
                  if (f && f.animate) f.animate([{ transform: 'translateX(0)' }, { transform: 'translateX(-6px)' }, { transform: 'translateX(6px)' }, { transform: 'translateX(0)' }], { duration: 300 });
                  var i2 = document.getElementById('pkCcIn'); if (i2) { i2.value = ''; i2.placeholder = window.matchMedia('(max-width: 480px)').matches ? "Invalid or already used" : "Code invalid, expired, or already used"; }
                };
                showErr();
                setTimeout(showErr, 400); /* survive the re-render that follows the refresh */
              }
            });
          }).catch(function () {});
      }
      if (t.closest && t.closest('#pkRmCode')) {
        fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ discount: '' }) })
          .then(function () { return refreshDrawer(); }).catch(function () {});
      }
      if (t.closest && t.closest('#pkCcIn')) return;
    });
    document.addEventListener('keydown', function (e) {
      if (e.target && e.target.id === 'pkCcIn' && e.key === 'Enter') {
        e.preventDefault();
        var b = document.getElementById('pkCcApply'); if (b) b.click();
      }
    });
    /* re-render (debounced) whenever Shrine swaps any part of the drawer;
       render() disconnects the observer while it mutates, so no self-loops */
    var moT;
    pkMo = new MutationObserver(function () {
      clearTimeout(moT);
      moT = setTimeout(render, 120);
    });
    pkObserve();
    window.addEventListener('resize', function () { fxCanvas(); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { wire(); render(); });
  } else { wire(); render(); }
})();
